import { Pager } from './pager';

/**
 * Blueprint for the pager options object.
 */
export class PagerOptions {
  public baseApi: string;
  public customQueries: Array<{ key: string; value: string }>;
  public pager: Pager;

  public constructor(api: string, customQueries: any, pager: Pager) {
    this.baseApi = api;
    this.customQueries = customQueries;
    this.pager = pager;
  }
}
